module.exports = __webpack_public_path__ + "static/prosty-crm-dla-handlowca-ff971a9deead4b2511c49d1af0beb05d.png";